import type { Address } from '~/types/commercetools';

const getVatNumberFromCustomerAddress = (address: Partial<Address>): string => {
  return address[vatNumberKeyOfCustomerAddress] ?? '';
};
export const vatNumberKeyOfCustomerAddress = 'fax';

export default getVatNumberFromCustomerAddress;
